import { inRange, update } from 'lodash';
import { ajaxSuccess } from './helpers';

const LOGIN_SUBMIT_BTN_SPINNER = `<i class="fa fa-circle-notch fa-spin m-auto text-PINK"></i>`;

const _showFormPinContainer = ($container = $('#auth-container .form-pin-container'), $button = null) => {
    if($button) $button.html($button.data('pinNotFound'))
    const _tpl = document.querySelector('template#auth-pin-template').content.cloneNode(true)
    $container.html(_tpl)
    $container.on('shown.bs.collapse', function() {
        $container.find('input[name="pin"]').trigger('focus')
    })
    $container.collapse('show')
}
const _hideFormPinContainer = ($container = $('#auth-container .form-pin-container'), $button = null) => {
    if($button) $button.html($button.data('pinExists'))
    $container.collapse('hide')
    $container.empty()
}

$(document).on('click', '#auth-container #form-pin-exists', function(e) {
    e.preventDefault();
    const $box          = $(this).closest('.box');
    const $container    = $box.find('.form-pin-container')

    if($container.children().length) _hideFormPinContainer($container, $(this))
    else _showFormPinContainer($container, $(this))

    return true
})

$(document).on('keyup', '#form-auth #form-auth-pin', function(e) {
    e.preventDefault()
    if(this.value.length == 4 && this.value != this.oldValue) $('#form-auth').trigger('submit')
    this.oldValue = this.value
})

$(document).on('submit', '#form-auth', function(e) {
    e.preventDefault()
    const formValidity = this.reportValidity()
    if(!formValidity) return;
    
    const self = this

    const formSubmitBtn     = this.querySelector('button[type="submit"]')
    const formPinExists     = document.getElementById('form-pin-exists')

    const _oldBtnContent    = formSubmitBtn.innerHTML;

    formSubmitBtn.setAttribute('disabled', true)
    formPinExists.setAttribute('disabled', true)

    formSubmitBtn.innerHTML = LOGIN_SUBMIT_BTN_SPINNER;

    const data = Array.from(this.elements)
    .filter(el => el instanceof HTMLInputElement)
    .filter(el => el.name != '_token')
    .map(el => {
        return {
            key: el.name,
            value: el.value
        }
    })
    .reduce((obj, item) => ({
        ...obj, 
        [item.key]: item.value
    }), {})

    axios({
        method: 'POST',
        url: this.action,
        data: data,
        errorHandler: true
    })
    .then((res) => {
        ajaxSuccess(res);
        const { data: { type = null } } = res.data

        if(type == 'pinGenerated') {
            _showFormPinContainer($(self).find('.form-pin-container'), $(self).find('#form-pin-exists'))
            formSubmitBtn.innerHTML = _oldBtnContent
            formSubmitBtn.removeAttribute('disabled')
            formPinExists.removeAttribute('disabled')
        } else if(type == 'auth') {
            const { data: { redirect = '/' } } = res.data
            window.location.replace(redirect)
        }
    }, (err) => {
        formSubmitBtn.innerHTML = _oldBtnContent
        formSubmitBtn.removeAttribute('disabled')
        formPinExists.removeAttribute('disabled')
        if(err?.response?.status === 412) _hideFormPinContainer($(self).find('.form-pin-container'), $(self).find('#form-pin-exists'))
    })
})